// extracted by mini-css-extract-plugin
module.exports = {"VolumeMuteButton":"VolumeBar_VolumeMuteButton__9gEaY","VolumeMuteButtonSvg":"VolumeBar_VolumeMuteButtonSvg__3D-pZ"};